// extracted by mini-css-extract-plugin
export default {"errorMessage":"mapa_errorMessage__QNDYr","inputFooter":"mapa_inputFooter__0KmVQ"};